/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBluetoothConnected = createReactComponent("outline", "bluetooth-connected", "IconBluetoothConnected", [["path", { "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8", "key": "svg-0" }], ["path", { "d": "M4 12l1 0", "key": "svg-1" }], ["path", { "d": "M18 12l1 0", "key": "svg-2" }]]);

export { IconBluetoothConnected as default };
//# sourceMappingURL=IconBluetoothConnected.mjs.map
